import {react2panel} from 'common/util/react2panel';

import {InsightsPieChartReact} from './index';

export const InsightsPieChartEl = react2panel(`mp-insights-pie-chart`, InsightsPieChartReact, {
  contexts: [`segmentFilterController`],
});
